import React, { ReactNode } from "react";

import Switch from "antd/es/switch";
import cn from "classnames";

import styles from "./Section.module.scss";

interface Props {
  checked?: boolean;
  children?: ReactNode;
  className?: string;
  onToggle?: (checked: boolean) => void;
  title?: ReactNode;
  toggleDisabled?: boolean;
}

const Section: React.FC<Props> = ({
  checked,
  children,
  className,
  onToggle,
  title,
  toggleDisabled,
}) => {
  return (
    <div className={cn(styles.container, className)}>
      <div className={styles.header}>
        <div className={styles.title}>{title}</div>
        {onToggle && <Switch checked={checked} disabled={toggleDisabled} onChange={onToggle} />}
      </div>
      {(!onToggle || (!!onToggle && checked)) && <div className={styles.content}>{children}</div>}
    </div>
  );
};

export default Section;
